import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionRendererComponent } from './components/version-renderer/version-renderer.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { ApiTokenInterceptor } from '@core/services/interceptors/api-token.interceptor';
import { FORM_ERRORS } from './constants/forms/form-errors.constants';
import { WLCM_ICONS_CONFIG } from '@shared/constants/icons.constants';
import { GusDateAdapter } from './services/date-picker.api';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { WLCM_ERRORS } from '@wlcm/angular/forms';
import { WLCM_ICONS } from '@wlcm/angular/core';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from '@environment';
import { enUS } from 'date-fns/locale';
import { ErrorInterceptor } from './services/interceptors/error.interceptor';

export const GUS_DEFAULT_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MMM/dd/yyyy',
  },
  display: {
    dateInput: 'MMM/dd/yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'MMM/dd/yyyy',
    monthYearA11yLabel: 'MMM yyyy',
  },
};

@NgModule({
  imports: [CommonModule, NgxStripeModule.forRoot(environment.stripeKey)],
  declarations: [VersionRendererComponent],
  exports: [VersionRendererComponent],
  providers: [
    { provide: WLCM_ERRORS, useValue: FORM_ERRORS },
    { provide: WLCM_ICONS, useValue: WLCM_ICONS_CONFIG },
    { provide: MAT_DATE_LOCALE, useValue: enUS },
    { provide: MAT_DATE_FORMATS, useValue: GUS_DEFAULT_DATE_FORMATS },
    { provide: DateAdapter, useClass: GusDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: HTTP_INTERCEPTORS, useClass: ApiTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
})
export class CoreModule {}
